import http from '../_http'

const credit = {
  //default
  summaryCredit: (m) => { return http.get(`manager/history/credit`, m); },
  listCredit: (m) => { return http.post(`manager/history/credit/list`, m); },
  detailCredit: (m) => { return http.get(`manager/history/credit/${m.id}`); },

  //crud
  insertCredit: (m) => { return http.post(`manager/history/credit`, m); },
  updateCredit: (m) => { return http.put(`manager/history/credit`, m); },
  deleteCredit: (m) => { return http.delete(`manager/history/credit/${m.id}`); },
}

export default credit

export { credit }